var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{class:_setup.classes},[(_vm.icon)?_c('i',{staticClass:"tw:inline-block tw:translate-y-[0.03em]",class:[_vm.icon, _vm.iconClass],attrs:{"aria-hidden":"true"}}):_vm._e(),_vm._t("default",function(){return [_vm._v(_vm._s(_vm.label))]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }